import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-374253be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coin-history-detail-section" }
const _hoisted_2 = { class: "coin-history-detail-container" }
const _hoisted_3 = { class: "month" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "list-container" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { class: "details" }
const _hoisted_8 = { class: "top" }
const _hoisted_9 = { class: "title-1" }
const _hoisted_10 = { class: "list-container" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "details" }
const _hoisted_13 = { class: "top" }
const _hoisted_14 = { class: "title-1" }
const _hoisted_15 = { class: "list-container" }
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = { class: "details no-line" }
const _hoisted_18 = { class: "top" }
const _hoisted_19 = { class: "title-1" }
const _hoisted_20 = { class: "month-last" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "list-container" }
const _hoisted_23 = { class: "icon" }
const _hoisted_24 = { class: "details" }
const _hoisted_25 = { class: "top" }
const _hoisted_26 = { class: "title-1" }
const _hoisted_27 = { class: "list-container" }
const _hoisted_28 = { class: "icon" }
const _hoisted_29 = { class: "details" }
const _hoisted_30 = { class: "top" }
const _hoisted_31 = { class: "title-1" }
const _hoisted_32 = { class: "list-container" }
const _hoisted_33 = { class: "icon" }
const _hoisted_34 = { class: "details" }
const _hoisted_35 = { class: "top" }
const _hoisted_36 = { class: "title-1" }
const _hoisted_37 = { class: "list-container" }
const _hoisted_38 = { class: "icon" }
const _hoisted_39 = { class: "details" }
const _hoisted_40 = { class: "top" }
const _hoisted_41 = { class: "title-1" }

export function render(_ctx, _cache) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton",
            width: "156px",
            height: "16px"
          })
        ]),
        _createVNode(_component_q_skeleton, {
          class: "skeleton-circle",
          width: "36px",
          height: "36px"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton-circle",
            width: "36px",
            height: "36px"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_skeleton, {
                class: "skeleton",
                width: "91px",
                height: "16px"
              })
            ]),
            _createVNode(_component_q_skeleton, {
              class: "skeleton",
              width: "49px",
              height: "16px"
            })
          ]),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title",
            width: "172px",
            height: "12px"
          }),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title-bottom",
            width: "74px",
            height: "12px"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton-circle",
            width: "36px",
            height: "36px"
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_q_skeleton, {
                class: "skeleton",
                width: "91px",
                height: "16px"
              })
            ]),
            _createVNode(_component_q_skeleton, {
              class: "skeleton",
              width: "49px",
              height: "16px"
            })
          ]),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title",
            width: "172px",
            height: "12px"
          }),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title-bottom",
            width: "74px",
            height: "12px"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton-circle",
            width: "36px",
            height: "36px"
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_q_skeleton, {
                class: "skeleton",
                width: "91px",
                height: "16px"
              })
            ]),
            _createVNode(_component_q_skeleton, {
              class: "skeleton",
              width: "49px",
              height: "16px"
            })
          ]),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title",
            width: "172px",
            height: "12px"
          }),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title-bottom",
            width: "74px",
            height: "12px"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton",
            width: "156px",
            height: "16px"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton-circle",
            width: "36px",
            height: "36px"
          })
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_q_skeleton, {
                class: "skeleton",
                width: "91px",
                height: "16px"
              })
            ]),
            _createVNode(_component_q_skeleton, {
              class: "skeleton",
              width: "49px",
              height: "16px"
            })
          ]),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title",
            width: "172px",
            height: "12px"
          }),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title-bottom",
            width: "74px",
            height: "12px"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton-circle",
            width: "36px",
            height: "36px"
          })
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_q_skeleton, {
                class: "skeleton",
                width: "91px",
                height: "16px"
              })
            ]),
            _createVNode(_component_q_skeleton, {
              class: "skeleton",
              width: "49px",
              height: "16px"
            })
          ]),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title",
            width: "172px",
            height: "12px"
          }),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title-bottom",
            width: "74px",
            height: "12px"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton-circle",
            width: "36px",
            height: "36px"
          })
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_q_skeleton, {
                class: "skeleton",
                width: "91px",
                height: "16px"
              })
            ]),
            _createVNode(_component_q_skeleton, {
              class: "skeleton",
              width: "49px",
              height: "16px"
            })
          ]),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title",
            width: "172px",
            height: "12px"
          }),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title-bottom",
            width: "74px",
            height: "12px"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_q_skeleton, {
            class: "skeleton-circle",
            width: "36px",
            height: "36px"
          })
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_q_skeleton, {
                class: "skeleton",
                width: "91px",
                height: "16px"
              })
            ]),
            _createVNode(_component_q_skeleton, {
              class: "skeleton",
              width: "49px",
              height: "16px"
            })
          ]),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title",
            width: "172px",
            height: "12px"
          }),
          _createVNode(_component_q_skeleton, {
            class: "skeleton title-bottom",
            width: "74px",
            height: "12px"
          })
        ])
      ])
    ])
  ]))
}